import { Controller } from '@hotwired/stimulus';
import { application } from 'src/app';
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { API } from 'src/api';

application.register('f-superset', class extends Controller {
  static values = {
    requestPath: String,
    domain: String,
    resourceId: String,
    resourceType: String,
    requestBody: Object,
    hideTitle: { type: Boolean, default: true },
    hideTab: { type: Boolean, default: true },
    hideChartControls: { type: Boolean, default: true },
    filtersExpanded: { type: Boolean, default: false }
  }

  get csrfToken() {
    return document.querySelector("[name='csrf-token']").content
  }

  get requestBody() {
    return this.hasRequestBodyValue ? this.requestBodyValue : {};
  }

  changeDashboard({ detail: { dashboardId }}) {
    this.resourceIdValue = dashboardId;
  }

  resourceIdValueChanged() {
    this.embeddedChart();
  }

  embeddedChart() {
    embedDashboard(
      {
         id: this.resourceIdValue,
         supersetDomain: this.domainValue,
         mountPoint: this.element,
         fetchGuestToken: this.fetchGuestToken.bind(this),
         dashboardUiConfig: {
         hideTitle: this.hideTitleValue,
         hideTab: this.hideTabValue,
         hideChartControls: this.hideChartControlsValue,
         filters: {
           expanded: this.filtersExpandedValue
         }
       }
     }
   );
  }

  fetchGuestToken() {
    return API.superset.fetchGuestToken(
      this.csrfToken,
      this.requestPathValue,
      { resource_id: this.resourceIdValue, resource_type: this.resourceTypeValue, ...this.requestBody }
    );
  }
})
